import { render, staticRenderFns } from "./OrdenesHistorialEdit.vue?vue&type=template&id=0d003976&"
import script from "./OrdenesHistorialEdit.vue?vue&type=script&lang=js&"
export * from "./OrdenesHistorialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports